<template>
  <div class="layout-page">
     <bottom></bottom>
    <div id="scroll-div-new" class="aui-scrollView">
      <swiper v-if="adList.length > 0" :ad-list="adList"></swiper>
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="getBooks"
      >
      <ul class="ul">
        <li v-for="(item, index) in categoryList" :key="item.id" :class="{ active: getCategoryActive === item.id }"  @click="changeCategory(item.id,0)">{{ item.name }}</li>
      </ul>

       <books-large :show-title="false" :books="list"></books-large>
      </van-list>
    </div>
    <div v-if="isMainLoading" class="home-main-loading"></div>
  </div>
</template>

<script>
import Swiper from '@/components/share/swiper'
import Bottom from '@/components/layer1/bottom'
import BooksLarge from '@/components/share/books-large'

import swiperService from '@/services/swiperService'
import listService from '@/services/listService'

export default {
  name: 'new',
  data () {
    return {
      componentName: '',
      adList: [],
      loading: false,
      finished: false,
      finishedText: '',
      list: [],
      currentPage: 1,

      categoryList: [],
      selected: {
        category: 0,
        pageSize: 6,
      },
      todayUpdateBooks:[],
      todayUpdateCurrentPage: 0,
      isLoading: false,
      isMainLoading: false,
      isNoMoreData: false,
      totalItem: 0,
    }
  },
  methods: {
    getBooks () {
      const { finished, currentPage, list } = this
      if (finished) return
      let _category = this.selected.category === 0 ? '' : this.selected.category
      listService.getUpdateList(_category, this.selected.pageSize, currentPage).then(res => {
        const resData = res.data
        const bookList = resData.bookList || []
        this.loading = false
        this.list = list.concat(bookList)
        if (currentPage >= resData.totalPage || bookList.length === 0) {
          this.finished = true
          if (this.list.length > 6) {
            this.finishedText = '没有更多了'
          } else {
            this.finishedText = ''
          }
        } else {
          this.currentPage++
        }
      })
    },
    returnPage () {
      this.$router.isBack = true
      this.$router.go(-1)
    },
    returnHome () {
      this.$router.isBack = false
      this.$router.push('/home')
    },

    //获取分类
    getCategory () {
      listService.getCategory().then(res => {
        this.categoryList = res.data.categoryList
      })
    },
     //换一批
     changeCategory(id,page) {
      this.selected.category = id;
      console.log(this.selected.category)
      if(page === 0){
        this.todayUpdateCurrentPage = 0;
      }
      this.getCategoryBooks(this.selected.category);
    },
    //请求下一批
    getCategoryBooks(category) {
      this.isMainLoading = true
      this.todayUpdateCurrentPage += 1;
      if(this.todayUpdateCurrentPage > 3){
        this.todayUpdateCurrentPage = 1
      }
      this.isLoading = true;
      this.isNoMoreData = false;
      this.list = [];
      let _category = category
      if (category === 0) {
        _category = ''
      }
      listService.getUpdateList(_category, this.selected.pageSize, this.todayUpdateCurrentPage, )
        .then(res => {
          this.isMainLoading = false;
          if (res.result) {
            if (res.data.totalPage === 0) {
              this.list = [];
            } else {
              this.list = res.data.bookList;
            }
            this.totalItem = res.data.totalItem;
          }
        })
    },

  },
  components: {
    swiper: Swiper,
    Bottom,
    'books-large': BooksLarge
  },
  computed: {
    getCategoryActive() {
      return this.selected.category
    }
  },
  mounted () {
    this.getCategory()
    this.componentName = this.$route.name
    if (
      this.$store.state.pageState[this.componentName]
    ) {
      Object.assign(
        this.$data,
        this.$store.state.pageState[this.$route.name].data
      )
      setTimeout(() => {
        const scrollDiv = document.getElementById('scroll-div-new')
        scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top
      }, 5)
    } else {
      this.adList = swiperService.getAdList()
    }
    this.$router.isBack = true
  },
  beforeDestroy () {
    const scrollDiv = document.getElementById('scroll-div-new')
    const state = {}
    state[this.componentName] = { data: this.$data, top: scrollDiv.scrollTop }
    this.$store.commit('saveState', state)
  }
}
</script>

<style scoped>

.ul{ display: flex; margin: -3px 0 0.3rem 0; flex-direction: row; flex-wrap: wrap; text-align: center;justify-content: left; padding: 10px 10px 3px 10px;
background: #e75b9a; border-radius: 10px; margin: 10px;}
.ul li{ margin: 0 0.1rem 0.4rem 0.1rem;  text-align: center;font-size:.8rem; background: #91174e; height: 1.4rem; line-height: 1.4rem;
    padding: 0; border-radius: .8rem; color: #fff;min-width: 3rem; border: 0px solid #91174e; text-align: center; width: 19%;}
.ul li.active{ background: #fff; color: #91174e;}

.home-main-loading{position: fixed; background:#000 url(../../assets/img/loading4.gif) center center no-repeat; background-size: 40px; 
    top: calc(50% - 60px); left: calc(50% - 60px); z-index: 2020; opacity: .7; width: 120px; height: 120px; border-radius: 10px;}

</style>

